import React from "react";
import "./Pagination.sass";

const Pagination = ({ pages, currentPage, city, handleClick }) => {
  const printPages = new Array(pages).fill(0);

  return (
    <ul className="Pagination">
      {printPages.map((item, index) => (
        <li>
          <button
            className={currentPage === index + 1 && "--active"}
            onClick={() => handleClick(index + 1)}
          >
            {index + 1}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default Pagination;
